import React, { useEffect, useState } from "react";
import Head from "next/head";
import striptags from "striptags";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";

const Layout = dynamic(() => import("../components/common/Layout/Layout"));
const Loader = dynamic(() => import("../components/common/Loader/Loader"));

const privacypolicy = ({ apiData }) => {
  const [privacyData, setPrivacyData] = useState();
  const [loader, setLoader] = useState(true);

  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const search_description = apiData?.meta?.search_description;
  const canonicalUrl = apiData?.canonical_url;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }

  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  useEffect(() => {
    const policyData = apiData?.detail;
    policyData && setPrivacyData(policyData);

    if (footerData) {
      setLoader(false);
    }
  }, []);

  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}
      </Head>

      <Layout
        webLogo={
          footerData &&
          footerData?.site_configuration &&
          footerData?.site_configuration[0]?.logo?.url
        }
      >
        {loader && <Loader />}
        <main className="main-wrapper terms-policy-middle wrapper-top-bg">
          <article className="wrapper-inner">
            <section className="default-hero-section light-primary-background">
              <div className="default-hero-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      {privacyData?.map((val, index) => {
                        // const titleWithoutPTag = striptags(
                        //   val?.value?.title,
                        //   "<span>"
                        // );
                        const titleWithoutPTag = val?.value?.title || "";
                        return (
                          <React.Fragment key={`${index}_j`}>
                            {val?.type ==
                              "title_description_paragraph_section" && (
                                <div className="heading">
                                  <span
                                    className="heading-h1"
                                    itemProp="heading"
                                    dangerouslySetInnerHTML={{
                                      __html: titleWithoutPTag,
                                    }}
                                  ></span>
                                  <p
                                    itemProp="description"
                                    dangerouslySetInnerHTML={{
                                      __html: val?.value?.description,
                                    }}
                                  ></p>
                                </div>
                              )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="terms-policy-section">
              <div className="terms-policy-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      {privacyData?.map((val, index) => {
                        return (
                          <React.Fragment key={`${index}_j`}>
                            {val?.type ==
                              "title_description_paragraph_section" && (
                                <div
                                  className="terms-policy-content"
                                  dangerouslySetInnerHTML={{
                                    __html: val?.value?.paragraph,
                                  }}
                                ></div>
                              )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </article>
        </main>
      </Layout>
    </>
  );
};

export async function getServerSideProps() {
  // Fetch data from your API
  const response = await fetch(
    process.env.NEXT_PUBLIC_API_ENDPOINT + "/cms/pages/privacy-policy/",
    { next: { revalidate: 3600 } }
  );
  const apiData = await response.json();

  return {
    props: {
      apiData,
    },
  };
}

export default privacypolicy;
